import React, {useEffect, useState} from "react";
import styles from "./LocationGymPopup.module.scss";
import {useTranslation} from "react-i18next";
import selectArrowDark from "../../assets/images/icons/select-arrow-dark.svg";
import closeBtn from "../../assets/images/icons/close-pupup-dark.svg"
import CustomButton from "../UI/CustomButton/CustomButton";
import useAppDispatch from "../../hooks/useAppDispatch";
import {IMultiGymInfo, setActiveGym, setFranchiseGymsList} from "../../store/multiGyms/multiGymsSlice";
import {MultiGymService} from "../../services/multiGym.service";
import useAppSelector from "../../hooks/useAppSelector";
import {$clientApi} from "../../http";
import useDisableScroll from "../../hooks/useDisableScroll";
import {openMessage} from "../../store/notification/notificationSlice";
import {AuthService} from "../../services/auth.service";

interface ILocationGymPopupProps {
    fromApp: boolean;
    closePopupFn: () => void;
}

const LocationGymPopup: React.FC<ILocationGymPopupProps> = ({fromApp, closePopupFn}) => {
    useDisableScroll();
    const {t} = useTranslation();
    const dispatch = useAppDispatch();

    const {isAuthorized} = useAppSelector(state => state.profileSlice);
    const {activeGym, franchiseGymsList} = useAppSelector(state => state.multiGymsSlice);

    const [selectedGym, setSelectedGym] = useState<IMultiGymInfo | null>(null);
    const [dropDownVisible, setDropDownVisible] = useState(false);

    useEffect(() => {
        getFranchiseGyms();
    }, []);

    const getFranchiseGyms = async () => {
        try {
            let token = localStorage.getItem("refresh_token");
            if (!token) token = "";
            const response = await MultiGymService.getFranchiseGyms(token);
            dispatch(setFranchiseGymsList(response.data.data));
        } catch (e) {}
    }

    const renderDropDownItem = (el: IMultiGymInfo) => {

        const clickOnDropDownItem = (el: IMultiGymInfo) => {
            console.log("isAuthorized", isAuthorized);
            setSelectedGym(el);
            setDropDownVisible(false);
        }

        return (
            <div key={el.id} className={styles.item} onClick={() => clickOnDropDownItem(el)}>
                <p className={styles.itemTitle}>{el.name}</p>
                <p className={styles.itemText}>{el.country}, {el.city} {el.street} {el.streetNumber}</p>
            </div>
        )
    }

    const clickOnContinue = async () => {
        console.log("isAuthorized", isAuthorized);
        console.log("selectedGym", selectedGym);
        if (!selectedGym) return;
        if (isAuthorized) {
            if (!selectedGym.isUserRegistered) {
                dispatch(openMessage({type: "error", title: t("YouAreNotRegisteredInTheSelectedGym")}));
                return;
            }
            const isTokenChanged = await getTokenForSelectedGym(selectedGym.id);
            console.log("isTokenChanged", isTokenChanged);
            localStorage.setItem("active_gym_info", JSON.stringify(selectedGym));
            $clientApi.defaults.baseURL = selectedGym.endpoint;
            dispatch(setActiveGym(selectedGym));
            closePopupFn();
            // TODO have to make login and change bearer
        } else {
            localStorage.setItem("active_gym_info", JSON.stringify(selectedGym));
            $clientApi.defaults.baseURL = selectedGym.endpoint;
            dispatch(setActiveGym(selectedGym));
            closePopupFn();
        }
    }

    const getTokenForSelectedGym = async (gymId: number) => {
        try {
            const response = await AuthService.getGymTokenById(gymId);
            console.log(response);
            if (response.data && response.data.refresh_token) {
                AuthService.setTokens({access_token: response.data.access_token, refresh_token: response.data.refresh_token})
                // $clientApi.defaults.headers.common["Authorization"] = `Bearer ${"eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjQzMjI4MDEwNDAsImlhdCI6MTczMDgwMTA0MCwianRpIjoiSldUSUQ1RkhENkVLIiwic3ViIjoiZ2Vrb2plczkzNEBhbnlwbmcuY29tIiwicm9sZSI6WyJST0xFX0NVU1RPTUVSIl0sInVzZXJJZCI6MzA1MTY1LCJwcm9maWxlSWQiOjMwMzg3MiwicHJvZmlsZSI6eyJpZCI6MzAzODcyLCJmaXJzdG5hbWUiOiJ0ZXN0IiwibGFzdG5hbWUiOiIxMjM0IiwiZGVmYXVsdEd5bUlkIjpudWxsfSwiYWxsb3dlZEVuZFBvaW50cyI6WyJodHRwczovL2JldGEwNy1zZXJ2ZXIudHJhaW55b3VycHVsc2UuY2x1YiIsImh0dHBzOi8vYmV0YTA3LnRyYWlueW91cnB1bHNlLmNsdWIiXX0.sMsqVif7xDn0stPyRnDebrGmM4_FB_bNo1mJKKrecm-3w9Urk_OGPB8lc_0FBDO03fD662u8G9m7gmvIMeebjlmZT77-CF5iY93p6gpJ65TbTnL7fzZfUraQr4LdgtDhNQ1fgYpxsSkhERfzqZaMpurdH_ZWXNFR2yoWo6oVF4ch1SztRJ8EH084sN6WkwGO59WHxIUb_LxplZNZ1vceRbIU8tNiFSomjRpgQCI756QEI36bvFKT6ochBehR2WcWalKvEOb1mvIFUcAXMHwriPtrXO-0OtLiyex5wTy_PGS5XBCH-q5fS4Y6Qpnm8Ei_LAiPwHKmOlx_IyNHaO7Vnw"}`;
                console.log("make token change");
            } else {
                return false;
            }
        } catch (e) {
            console.log(e)
            return false;
        }
    }

    return (
        <div className={`${styles.container} ${fromApp && styles.fromApp}`}>
            <div className={styles.popup}>
                {
                    !fromApp && (
                        <div className={styles.closeBtnWrapper}>
                            <img onClick={closePopupFn} src={closeBtn} alt={"close"}/>
                        </div>
                    )
                }
                <svg className={styles.icon} width="100" height="100" viewBox="0 0 100 100" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect width="100" height="100" rx="50" fill="#EF5D60" fillOpacity="0.1"/>
                    <path
                        d="M34.6003 63.5334C35.3429 63.3168 36.1412 63.4041 36.8194 63.776C37.4977 64.148 38.0004 64.7741 38.217 65.5167C38.4336 66.2593 38.3463 67.0575 37.9744 67.7358C37.6024 68.4141 36.9763 68.9168 36.2337 69.1334C34.7753 69.5592 33.7253 70.0084 33.0516 70.4167C33.7457 70.8338 34.8424 71.3005 36.3649 71.735C39.7337 72.6975 44.5549 73.3334 50.0003 73.3334C55.4457 73.3334 60.267 72.6975 63.6357 71.735C65.1612 71.3005 66.2549 70.8338 66.9491 70.4167C66.2782 70.0084 65.2282 69.5592 63.7699 69.1334C63.039 68.9072 62.4262 68.403 62.0636 67.7292C61.701 67.0555 61.6177 66.2663 61.8316 65.5317C62.0454 64.7971 62.5394 64.1759 63.207 63.8021C63.8745 63.4283 64.6623 63.3318 65.4003 63.5334C67.3487 64.1021 69.1337 64.8313 70.5045 65.7675C71.7732 66.6396 73.3337 68.1592 73.3337 70.4167C73.3337 72.7005 71.7353 74.2317 70.4462 75.1038C69.052 76.043 67.2291 76.775 65.237 77.3438C61.2178 78.4959 55.8337 79.1667 50.0003 79.1667C44.167 79.1667 38.7828 78.4959 34.7637 77.3438C32.7716 76.775 30.9487 76.043 29.5545 75.1038C28.2653 74.2288 26.667 72.7005 26.667 70.4167C26.667 68.1592 28.2274 66.6396 29.4962 65.7675C30.867 64.8313 32.652 64.1021 34.6003 63.5334ZM50.0003 20.8334C55.8019 20.8334 61.3659 23.1381 65.4683 27.2404C69.5706 31.3428 71.8753 36.9068 71.8753 42.7084C71.8753 50.1984 67.792 56.2884 63.5628 60.6167C61.8816 62.3198 60.0751 63.8944 58.1582 65.3271C56.4257 66.628 52.4649 69.0663 52.4649 69.0663C51.7137 69.4933 50.8644 69.7178 50.0003 69.7178C49.1362 69.7178 48.287 69.4933 47.5357 69.0663C45.5692 67.9278 43.6684 66.6795 41.8424 65.3271C39.9248 63.8953 38.1182 62.3207 36.4378 60.6167C32.2087 56.2884 28.1253 50.1984 28.1253 42.7084C28.1253 36.9068 30.43 31.3428 34.5324 27.2404C38.6347 23.1381 44.1987 20.8334 50.0003 20.8334ZM50.0003 26.6667C45.7458 26.6667 41.6655 28.3568 38.6572 31.3652C35.6488 34.3736 33.9587 38.4539 33.9587 42.7084C33.9587 48.005 36.8637 52.7067 40.6087 56.5334C43.4262 59.415 46.5295 61.6084 48.6791 62.9559L50.0003 63.755L51.3216 62.9559C53.4682 61.6084 56.5745 59.415 59.392 56.5363C63.137 52.7067 66.042 48.008 66.042 42.7084C66.042 38.4539 64.3519 34.3736 61.3435 31.3652C58.3351 28.3568 54.2548 26.6667 50.0003 26.6667ZM50.0003 33.9584C51.1494 33.9584 52.2872 34.1847 53.3488 34.6244C54.4104 35.0642 55.375 35.7087 56.1875 36.5212C57 37.3337 57.6445 38.2983 58.0843 39.3599C58.524 40.4215 58.7503 41.5593 58.7503 42.7084C58.7503 43.8574 58.524 44.9953 58.0843 46.0569C57.6445 47.1185 57 48.083 56.1875 48.8956C55.375 49.7081 54.4104 50.3526 53.3488 50.7923C52.2872 51.232 51.1494 51.4584 50.0003 51.4584C47.6797 51.4584 45.4541 50.5365 43.8131 48.8956C42.1722 47.2546 41.2503 45.029 41.2503 42.7084C41.2503 40.3877 42.1722 38.1621 43.8131 36.5212C45.4541 34.8802 47.6797 33.9584 50.0003 33.9584ZM50.0003 39.7917C49.2268 39.7917 48.4849 40.099 47.9379 40.646C47.391 41.193 47.0837 41.9348 47.0837 42.7084C47.0837 43.4819 47.391 44.2238 47.9379 44.7708C48.4849 45.3177 49.2268 45.625 50.0003 45.625C50.7739 45.625 51.5157 45.3177 52.0627 44.7708C52.6097 44.2238 52.917 43.4819 52.917 42.7084C52.917 41.9348 52.6097 41.193 52.0627 40.646C51.5157 40.099 50.7739 39.7917 50.0003 39.7917Z"
                        fill="#EF5D60"/>
                </svg>
                <h2 className={styles.title}>{t("SelectALocation")}</h2>
                <p className={styles.subtitle}>{t("PleaseSelectYourLocation")}</p>
                <div className={styles.selectContainer}>
                    {
                        selectedGym ? (
                            <p className={styles.selectText}>{selectedGym.name}</p>
                        ) : (
                            <p className={styles.selectText}>{Object.keys(activeGym).length ? activeGym.name : "Select..."}</p>
                        )
                    }
                    <img
                        className={styles.arrow}
                        src={selectArrowDark}
                        alt={"arrow"}
                        onClick={() => setDropDownVisible(!dropDownVisible)}
                    />
                    {
                        dropDownVisible && (
                            <div className={styles.dropDownWrapper}>
                                {
                                    franchiseGymsList.map(el => renderDropDownItem(el))
                                }
                            </div>
                        )
                    }
                </div>
                <CustomButton
                    text={t("Continue")}
                    type={"button"}
                    typeStyle={"fill"}
                    borderRadius={false}
                    functionOnClick={clickOnContinue}
                />
            </div>
        </div>
    )

}

export default LocationGymPopup;